// 用户信息原子
import { atom } from 'jotai';
import { InfoRes } from '@/types/api/user/info.d';
import { SystemSettingsRes } from '@/types/api/user/system-settings.d';

export const userInfoAtom = atom<InfoRes | null>(null);

// 用户系统设置原子默认值
const defaultUserSystemSettings: SystemSettingsRes['userSystemSettings'] = {
  id: '',
  language: 'en',
  musicSwitch: true,
  soundEffectSwitch: true,
  stealthMode: false,
};

// 用户系统设置原子
export const userSystemSettingsAtom = atom<SystemSettingsRes['userSystemSettings']>(defaultUserSystemSettings);